export default __webpack_public_path__ + "static/media/sqlite.daf4a3a8.svg";